import { ConnectKitButton } from 'connectkit';
import { useEffect } from 'react';
import { useAccount } from 'wagmi';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import ButtonApi from '../ButtonApi';
import ThemeLogo from '../theme/ThemeLogo';

const LoginButton = ({ content = <></> }) => {
  const [{ user, userLoading, authDisabled, setAuthDisabled }] = useGlobalState();
  const { userLogin, openLogin } = useLoginHelper();
  const { isConnected, address, isConnecting } = useAccount();

  useEffect(() => {
    if (isConnected && !user && !userLoading && !authDisabled) {
      userLogin();
    }
  }, [isConnected, user, userLoading, authDisabled]);

  if (user) return <ConnectKitButton />;
  return (
    <ButtonApi className='navbar_login_button ellipse' onClick={openLogin}>
      {address ? (
        <>Begin</>
      ) : (
        <>
          Connect Wallet
          <ThemeLogo icon={'wallet'} />
        </>
      )}
    </ButtonApi>
  );
};

export default LoginButton;
